import * as React from 'react'
import cn from 'classnames'

export type SettingsTitleProps = {
  children: React.ReactNode
  className?: string
}

export const SettingsTitle = (props: SettingsTitleProps) => {
  const { children, className } = props

  return (
    <h1
      className={cn(
        'font-talent text-[27px] font-medium leading-[28px] text-[#1B1818] mb-16',
        className
      )}
    >
      {children}
    </h1>
  )
}
